import { Stack } from '@mui/material';

import { MembershipFragment } from '@occc/graphql';
import ExecuteLoyaltyEvents from '@occc-app/routes/Member/MemberDetailsPage/components/ExecuteLoyaltyEvents/ExecuteLoyaltyEvents';
import { useConfig } from '@occc/config';

import { SubBrands } from './SubBrands/sub-brands.component';
import Targeting from './Targeting';
import OffersAndVouchers from './OffersAndVouchers';
import Activity from './Activity';

import { displayFullName } from '../../utils';

type Props = {
  member: MembershipFragment;
};

export const ProgramContent = ({ member }: Props) => {
  const { config } = useConfig();
  const isSubBrandsAvailable = !!config.subBrands?.enabled;

  return (
    <Stack spacing={1}>
      <Activity memberId={member.id} stateChanges={member.stateChanges} />
      {isSubBrandsAvailable && (
        <SubBrands
          activeSubBrandUuid={member.lastSubBrandOffersQueriesUuid ?? null}
          subBrandList={config.subBrands?.list ?? []}
        />
      )}
      {member.customerUuid && (
        <ExecuteLoyaltyEvents
          memberName={displayFullName(member)}
          customerUuid={member.customerUuid}
        />
      )}
      <Targeting memberId={member.id} />
      <OffersAndVouchers memberId={member.id} />
    </Stack>
  );
};
